export default "__VITE_ASSET__DIPEgNB7__"